import React from "react";
import "./DisclaimerPopup.css";

const TermsAndConditions = () => {
  return (
    <div className="tc-container">
      <header className="tc-header">
        <h1>Disclaimers</h1>
      </header>

      <section className="tc-content">
        <p>
          Welcome to <strong>Varankal Matrimony</strong>, your personal matchmaking
          platform. This Agreement sets out the legally binding terms for your
          use of the Site and membership. This Agreement may be modified by
          Varankal Matrimony from time to time. The membership and rights of
          admissions are reserved.
        </p>

        <div className="tc-subpoints">
          <p>
            a. Varankal Matrimony is not responsible for any incorrect or inaccurate
            Content/listing posted on the Site or in connection with the Service,
            whether caused by Users, Members, or by any of the equipment or programming
            associated with or utilized in the Service, nor for the conduct of any
            User and/or Member of the Service whether online or offline.
          </p>

          <p>
            b. Varankal Matrimony assumes no responsibility for any error, omission,
            interruption, deletion, defect, delay in operation or transmission,
            communications line failure, theft or destruction or unauthorized
            access to, or alteration of, User and/or Member communications.
          </p>

          <p>
            c. Varankal Matrimony is not responsible for any problems or technical
            malfunction of any telephone network or lines, computer systems, servers,
            providers, software, failure of email, or players on account of technical
            problems or congestion on the Internet or any website.
          </p>

          <p>
            d. Under no circumstances will Varankal Matrimony be responsible for any
            loss or damage resulting from anyone's use of the Site or the Service
            and/or any Content posted on the Site or transmitted to Members.
          </p>

          <p>
            e. The exchange of matchmaking profile(s) through or by Varankal Matrimony
            is not a matrimonial offer or recommendation. The platform shall not be
            responsible for any loss or damage arising out of any relations
            established pursuant to the use of the service.
          </p>

          <p>
            f. The Site and the Service are provided "AS-IS" and Varankal Matrimony
            expressly disclaims any warranty of fitness for a particular purpose or
            non-infringement. The company cannot guarantee and does not promise any
            specific results from use of the Site or the Service.
          </p>

          <p>
            g. Varankal Matrimony expressly disclaims any liability or responsibility
            arising as a result of any Content/listing posted on the Site or made
            available by any Members or users of the Site or any third party.
          </p>

          <p>
            h. Varankal Matrimony does not assume any responsibility or liability for
            any illegal Content posted on the Site by any Members, users or any third
            party.
          </p>

          <p>
            i. All liability, whether civil or criminal, arising out of any Content
            that is posted on the Site will be of that Member / user / third party who
            has posted such Content. Varankal Matrimony reserves its right to claim
            damages from such individuals if it suffers as a result.
          </p>
        </div>
      </section>
    </div>
  );
};

export default TermsAndConditions;
